module.exports = __webpack_public_path__ + "okticon.a560e17e7ab1ae0cc271da8cf0c62d8a.eot";